<template>
  <el-dialog title="打印" :visible.sync="dialogPrintVisible" append-to-body>
    <el-form>
      <el-form-item label="纸张">
        <el-select v-model="printId" placeholder="请选择" @change="choosePrint" style="margin-bottom: 20px">
          <el-option
              v-for="item in printList"
              :key="item.id"
              :label="`${item.name} (${item.paperWidth}mm*${item.paperHeight}mm)`"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" style="margin-left: 50px" @click="printbatch" v-if="!isAll">打印</el-button>
        <el-button type="primary" style="margin-left: 50px" @click="printbatch" v-else>打印</el-button>
      </el-form-item>
      <el-form-item label="打印格式">
        <el-radio-group v-model="printType">
          <el-radio :label="1">名称</el-radio>
          <el-radio :label="2">名称+二维码</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div id="printAll" v-if="printType == 1">
      <div v-for="(item,index) in printDataList" :key="index" :id="'printItem'+index"
           style="border: 0.1mm #000 solid"
           :style="`width: ${paperWidth-0.2}mm ;height: ${paperHeight-0.4}mm;page-break-after: always;display:flex;align-items: center;justify-content:center;font-size:${paperWidth*(item.name.length>20?0.07:0.08)}mm;text-align: center;`">
        <div style="padding: 0.1mm">{{ item.name }}</div>
      </div>
    </div>
    <div id="printAll" v-if="printType == 2">
      <div v-for="(item,index) in printDataList" :key="index" :id="'printItem'+index"
           :style="`width: ${paperWidth}mm ;height: ${paperHeight-0.3}mm;page-break-after: always;display:flex;align-items: center;`">
        <div style="display: flex;flex-direction: column;"
             :style="`width: ${paperWidth-4}mm ;height: ${paperHeight-4}mm;border:0.4mm black solid;page-break-after: always;margin:0 auto;`">
          <div
              style="font-weight: 600;border-bottom: 0.4mm #000 solid;text-align: center;justify-content: center;align-content:center"
              :style="{'height':paperHeight*0.3+'mm','font-size':paperWidth*(item.name.length>20?0.05:0.06)+'mm'}">
            {{ item.name }}
          </div>
          <div style="text-align: center;margin-top: 1mm;justify-content: center;align-content:center"
               :style="{'height':paperHeight*0.75+'mm'}">
            <vue-qr
                :size="1000"
                :margin="0"
                :auto-color="true"
                :dot-scale="1"
                :text="`?classId=${item.id}`"
                class="codeImage"
                :style="`width: ${codeWidth}mm;height: ${codeWidth}mm;display: block;margin: 0 auto`"
            />
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {selectAllPrintList} from '@/api/storeCodePrint.js'
import print from 'vue-print-nb'
import VueQr from 'vue-qr'

export default {
  directives: {print},
  data() {
    return {
      barcode_option: {
        displayValue: false,
      },
      codeWidth: 50,
      classHeight: 6,
      list: [],
      dialogPrintVisible: false,
      printId: '',
      printList: [],
      paperWidth: 70,
      paperHeight: 30,
      printDataList: [],
      isAll: false,
      printData: {},
      marginsWidth: 6,
      marginsHeight: 4,
      printType:1
    }
  },
  components: {VueQr},
  props: {},
  created() {
  },
  mounted() {
    this.getAllPrint()
  },
  methods: {
    init(list) {
      this.printDataList = list
      this.dialogPrintVisible = true
    },
    choosePrint() {
      // this.timer = new Date().getTime();
      let fe = this.printList.filter(item => {
        return item.id == this.printId
      })
      if (fe) {
        this.paperWidth = fe[0].paperWidth
        this.paperHeight = fe[0].paperHeight
      }
      this.initSize()
    },
    initSize() {
      this.codeWidth = parseInt(this.paperWidth)
      if (this.codeWidth > (this.paperHeight - this.marginsWidth) * 0.6) {
        this.codeWidth = parseInt((this.paperHeight - this.marginsHeight) * 0.5)
      }
      this.printDataList.forEach(item => {
        var lineHeight = parseInt((this.paperHeight - this.marginsHeight) * 0.6);
        if (lineHeight > 0) {
          item.classHeight = lineHeight
        }
      })
    },
    getAllPrint() {
      selectAllPrintList().then(res => {
        this.printList = res.data
        if (this.printList && this.printList.length > 0) {
          this.printId = this.printList[0].id
          this.choosePrint()
        }
      })
    },
    printbatch() {
      const printStyle = `<style>@media print{body{margin: 0; padding: 0;}}</style>`;
      var newWin = window.open(""); //新打开一个空窗口
      for (var i = 0; i < this.printDataList.length; i++) {
        var imageToPrint = document.getElementById("printItem" + i); //获取需要打印的内容
        newWin.document.write(imageToPrint.outerHTML); //将需要打印的内容添加进新的窗口
      }
      newWin.document.head.innerHTML = printStyle; //给打印的内容加上样式
      newWin.document.close(); //在IE浏览器中使用必须添加这一句
      newWin.focus(); //在IE浏览器中使用必须添加这一句
      setTimeout(function () {
        newWin.print(); //打印
        newWin.close(); //关闭窗口
      }, 100);
    }
  }
}
</script>
<style scoped>
@page {
  size: auto;
  margin: 0mm;
}
</style>
